<template>
  <div class="feedback-root">
    <div class="toast-stack">
      <article
        v-for="item in feedbackState.toasts"
        :key="item.id"
        class="toast-card"
        :class="`toast-card--${item.type}`"
      >
        <div class="toast-card__body">
          <div class="toast-card__title">
            {{ toastTitle(item.type) }}
          </div>
          <div class="toast-card__message">{{ item.message }}</div>
        </div>
        <button class="toast-card__close" type="button" @click="dismissToast(item.id)">关闭</button>
      </article>
    </div>

    <div v-if="feedbackState.confirm" class="feedback-confirm-backdrop" @click.stop>
      <section class="feedback-confirm" @click.stop>
        <div class="feedback-confirm__kicker">Action</div>
        <h4 class="feedback-confirm__title">{{ feedbackState.confirm.title }}</h4>
        <p class="feedback-confirm__message">{{ feedbackState.confirm.message }}</p>
        <div class="feedback-confirm__actions">
          <button class="btn btn-secondary" type="button" @click="closeConfirm(false)">
            {{ feedbackState.confirm.cancelText }}
          </button>
          <button
            class="btn"
            :class="feedbackState.confirm.tone === 'danger' ? 'btn-warm' : 'btn-primary'"
            type="button"
            @click="closeConfirm(true)"
          >
            {{ feedbackState.confirm.confirmText }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import feedbackState, { closeConfirm, dismissToast } from '@/utils/feedback';

function toastTitle(type) {
  if (type === 'success') {
    return '操作成功';
  }
  if (type === 'error') {
    return '操作失败';
  }
  return '系统提示';
}
</script>
